import { RANGE_OPTIONS, validateCustomRange, formatCustomLabel } from "@/lib/chartUtils";

export default function ChartRangePicker({
  value,
  onChange,
  customRange,
  onCustomChange,
  testid,
}) {
  const isCustom = value === "custom";
  const err = isCustom
    ? validateCustomRange(customRange?.from, customRange?.to)
    : null;

  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid={`${testid}-wrapper`}>
      <div
        className="inline-flex rounded-lg ring-1 ring-slate-300 bg-white p-0.5 text-xs"
        data-testid={testid}
        role="tablist"
      >
        {RANGE_OPTIONS.map((o) => (
          <button
            key={o.id}
            onClick={() => onChange(o.id)}
            data-testid={`${testid}-${o.id}`}
            role="tab"
            aria-selected={value === o.id}
            className={`px-2.5 py-1 rounded-md font-medium transition-colors ${
              value === o.id
                ? "bg-slate-900 text-white"
                : "text-slate-600 hover:bg-slate-50"
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>

      {isCustom && (
        <div className="flex items-center gap-2 text-xs" data-testid={`${testid}-custom-inputs`}>
          <input
            type="date"
            value={customRange?.from || ""}
            max={customRange?.to || undefined}
            onChange={(e) =>
              onCustomChange({ ...customRange, from: e.target.value })
            }
            data-testid={`${testid}-from`}
            className="rounded-md ring-1 ring-slate-300 bg-white px-2 py-1 text-slate-900 focus:ring-2 focus:ring-blue-600 focus:outline-none"
          />
          <span className="text-slate-400">→</span>
          <input
            type="date"
            value={customRange?.to || ""}
            min={customRange?.from || undefined}
            onChange={(e) =>
              onCustomChange({ ...customRange, to: e.target.value })
            }
            data-testid={`${testid}-to`}
            className="rounded-md ring-1 ring-slate-300 bg-white px-2 py-1 text-slate-900 focus:ring-2 focus:ring-blue-600 focus:outline-none"
          />
        </div>
      )}

      {isCustom && err && (
        <span
          className="text-xs text-red-600 font-medium"
          data-testid={`${testid}-custom-error`}
        >
          {err}
        </span>
      )}

      {isCustom && !err && customRange?.from && customRange?.to && (
        <span
          className="text-xs text-slate-500 font-medium"
          data-testid={`${testid}-custom-label`}
        >
          {formatCustomLabel(customRange.from, customRange.to)}
        </span>
      )}
    </div>
  );
}
